/* BLUMI storefront behaviour — ported from design-prototypes/blumi-c3.

   Cart submission is Dawn's <product-form>; this file covers the gallery, the
   offer selector and its synced views, the review marquee, the sticky bar and
   scroll reveals. Everything motion-related opts out under prefers-reduced-motion. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var smooth = reduce ? 'auto' : 'smooth';

  /* ---------------------------------------------------------------- gallery */

  function Gallery(root) {
    var track = root.querySelector('[data-gallery-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var slides = root.querySelectorAll('[data-gallery-slide]');
    if (!track || !slides.length) return;

    var index = 0;

    function mark(i) {
      index = Math.max(0, Math.min(i, slides.length - 1));
      thumbs.forEach(function (t, n) {
        var on = n === index;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: smooth });
      });
    }
    function go(i) {
      track.scrollTo({ left: track.clientWidth * i, behavior: smooth });
      mark(i);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.dataset.index, 10) || 0); });
    });
    root.querySelectorAll('[data-gallery-nav]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.dataset.galleryNav === 'next' ? 1 : -1;
        go((index + step + slides.length) % slides.length);
      });
    });

    var queued = false;
    track.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index) mark(i);
      });
    }, { passive: true });

    mark(0);
    root.blumiGallery = { goTo: go };
  }

  /* ------------------------------------------------- offer selector (3 views) */

  function Buy(root) {
    var variantInput = root.querySelector('[data-variant-input]');
    var offers = Array.prototype.slice.call(root.querySelectorAll('[data-offer]'));
    if (!variantInput || !offers.length) return;

    var priceNow = root.querySelector('[data-price-current]');
    var priceWas = root.querySelector('[data-price-compare]');
    var ctaPrice = root.querySelector('[data-cta-price]');
    var submit = root.querySelector('[data-add-button]');
    var submitLabel = submit && submit.querySelector('[data-add-label]');
    var stickySelect = document.querySelector('[data-sticky-select]');
    var stickyBar = document.querySelector('[data-blumi-sticky]');
    var stickyAdd = (stickyBar && stickyBar.dataset.stickyAddText) || null;
    var gallery = document.querySelector('[data-blumi-gallery]');
    var soldOut = root.dataset.soldOutText || 'Sold out';
    var addText = root.dataset.addText || 'Add to cart';

    function apply(offer, moveGallery) {
      var d = offer.dataset;
      variantInput.value = d.variantId || '';

      if (priceNow) priceNow.textContent = d.price || '';
      if (priceWas) {
        priceWas.textContent = d.compare || '';
        priceWas.hidden = !d.compare;
      }
      if (ctaPrice) ctaPrice.textContent = d.price || '';

      var out = d.available === 'false';
      if (submit) {
        submit.disabled = out;
        submit.setAttribute('aria-disabled', out ? 'true' : 'false');
        if (submitLabel) submitLabel.textContent = out ? soldOut : addText;
      }

      document.querySelectorAll('[data-sticky-price]').forEach(function (el) { el.textContent = d.price || ''; });
      document.querySelectorAll('[data-sticky-name]').forEach(function (el) { el.textContent = d.name || ''; });
      // the thumbnail follows the pack, so 2 tubes look like 2 tubes
      if (d.image) {
        document.querySelectorAll('[data-sticky-img]').forEach(function (el) {
          el.removeAttribute('srcset');
          el.src = d.image;
        });
      }
      document.querySelectorAll('[data-sticky-label]').forEach(function (el) {
        el.textContent = out ? soldOut : (stickyAdd || addText);
      });

      // .offer on the product page, .tile in the homepage hero — one selector for
      // both, and never assume closest() found something.
      offers.forEach(function (o) {
        var card = o.closest('.offer, .tile');
        if (card) card.classList.toggle('is-on', o === offer);
      });
      if (stickySelect && stickySelect.value !== d.variantId) stickySelect.value = d.variantId;

      if (moveGallery && gallery && gallery.blumiGallery && d.mediaIndex) {
        gallery.blumiGallery.goTo(parseInt(d.mediaIndex, 10));
      }
    }

    function byVariant(id) {
      var m = offers.filter(function (o) { return o.dataset.variantId === id; })[0];
      if (!m) return;
      m.checked = true;
      apply(m, true);
    }

    offers.forEach(function (o) {
      o.addEventListener('change', function () { if (o.checked) apply(o, true); });
      if (o.checked) apply(o, false);
    });
    if (stickySelect) {
      stickySelect.addEventListener('change', function () { byVariant(stickySelect.value); });
    }
  }

  /* --------------------------------------------------------- review marquee */

  function Marquee(rail) {
    var down = false, startX = 0, startLeft = 0;
    rail.addEventListener('pointerdown', function (e) {
      down = true; startX = e.clientX; startLeft = rail.scrollLeft;
      rail.classList.add('is-dragging');
      rail.setPointerCapture(e.pointerId);
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      rail.scrollLeft = startLeft - (e.clientX - startX);
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      rail.addEventListener(ev, function () { down = false; rail.classList.remove('is-dragging'); });
    });
  }

  /* -------------------------------------------------------------- sticky bar */

  function Sticky(bar) {
    var anchor = bar.dataset.anchor && document.getElementById(bar.dataset.anchor);
    if (!anchor) return;

    var trigger = bar.querySelector('[data-sticky-add]');
    if (trigger) {
      trigger.addEventListener('click', function () {
        var real = document.querySelector('[data-add-button]');
        if (real) real.click();
      });
    }

    // 120px past the real button: a bar that appears at 1px of scroll reads as a
    // popup rather than a helper.
    var queued = false;
    function update() {
      queued = false;
      bar.classList.toggle('is-on', anchor.getBoundingClientRect().bottom < -120);
    }
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ----------------------------------------------------------------- reveals */

  function reveals(scope) {
    var items = (scope || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* -------------------------------------------------------------------- init */

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-blumi-gallery]').forEach(function (el) { new Gallery(el); });
    root.querySelectorAll('[data-blumi-buy]').forEach(function (el) { new Buy(el); });
    root.querySelectorAll('[data-marquee]').forEach(function (el) { new Marquee(el); });
    root.querySelectorAll('[data-blumi-sticky]').forEach(function (el) { new Sticky(el); });
    reveals(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor re-renders one section at a time.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
